// apps/share-web/src/player-view/view-memo.ts
//
// Память экранов плеера: Master и петля, общие для телефонного экрана и широкой раскладки.
//
// У плеера (player.ts) нет геттеров Master и петли, а экран пересобирается на каждом
// переходе через порог 768 px (mount.ts: поворот телефона, ресайз окна) — без памяти
// поворот показывал бы Master на 0 dB при звуке на +6 и забывал петлю. Писать в неё обязаны
// ОБА экрана и читать оба: иначе значение, выставленное на одном, пропадает на другом.
//
// Ключ — ПЛЕЕР: он один на песню и переживает поворот, а следующая песня (и повторный заход в
// эту же) получает свежий плеер — со свежим Master и без петли, как в движке (main.ts создаёт
// плеер на каждый заход в песню). Ключ-shareId отдал бы им прошлый визит и переставил бы Master
// в строке, не тронув звук. Микс здесь не хранится: он живёт в самом движке (getTrackStates).
export interface ViewMemo {
  /** Множитель Master (1 = 0 dB). */
  master: number;
  /** Петля — id секции манифеста. */
  loopSectionId: string | null;
}

const memos = new WeakMap<object, ViewMemo>();

/** Память плеера (копия): у плеера без записей — Master 1 и петли нет. */
export function getViewMemo(player: object): ViewMemo {
  const m = memos.get(player);
  return m ? { ...m } : { master: 1, loopSectionId: null };
}

/** Записать названные поля; остальные остаются как были. */
export function setViewMemo(player: object, patch: Partial<ViewMemo>): void {
  memos.set(player, { ...getViewMemo(player), ...patch });
}
